"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";
import { MinusIcon } from "lucide-react";
import { cn } from "@/lib/utils";
function InputOTP(t0) {
  const $ = _c(12);
  let className;
  let containerClassName;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      containerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = containerClassName;
    $[3] = props;
  } else {
    className = $[1];
    containerClassName = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== containerClassName) {
    t1 = cn("flex items-center gap-2 has-disabled:opacity-50", containerClassName);
    $[4] = containerClassName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== className) {
    t2 = cn("disabled:cursor-not-allowed", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <OTPInput data-slot="input-otp" containerClassName={t1} className={t2} {...props} />;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function InputOTPGroup(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex items-center", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="input-otp-group" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function InputOTPSlot(t0) {
  const $ = _c(17);
  let className;
  let index;
  let props;
  if ($[0] !== t0) {
    ({
      index,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = index;
    $[3] = props;
  } else {
    className = $[1];
    index = $[2];
    props = $[3];
  }
  const inputOTPContext = React.useContext(OTPInputContext);
  let t1;
  if ($[4] !== index || $[5] !== inputOTPContext?.slots) {
    t1 = inputOTPContext?.slots[index] ?? {};
    $[4] = index;
    $[5] = inputOTPContext?.slots;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    char,
    hasFakeCaret,
    isActive
  } = t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn("data-[active=true]:border-ring data-[active=true]:ring-ring/50 data-[active=true]:aria-invalid:ring-destructive/20 dark:data-[active=true]:aria-invalid:ring-destructive/40 aria-invalid:border-destructive data-[active=true]:aria-invalid:border-destructive dark:bg-input/30 border-input relative flex h-9 w-9 items-center justify-center border-y border-r text-sm shadow-xs transition-all outline-none first:rounded-l-md first:border-l last:rounded-r-md data-[active=true]:z-10 data-[active=true]:ring-[3px]", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== hasFakeCaret) {
    t3 = hasFakeCaret && <div className="pointer-events-none absolute inset-0 flex items-center justify-center"><div className="animate-caret-blink bg-foreground h-4 w-px duration-1000" /></div>;
    $[9] = hasFakeCaret;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== char || $[12] !== isActive || $[13] !== props || $[14] !== t2 || $[15] !== t3) {
    t4 = <div data-slot="input-otp-slot" data-active={isActive} className={t2} {...props}>{char}{t3}</div>;
    $[11] = char;
    $[12] = isActive;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function InputOTPSeparator(t0) {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MinusIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <div data-slot="input-otp-separator" role="separator" {...props}>{t1}</div>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };